<!--
 * @Description: 教职工详情 专利成果
 * @Author: 张天伟
 * @Date: 2023-03-08 17:11:55
 * @LastEditors: PF
 * @LastEditTime: 2024-02-19 10:12:26
-->
<template>
  <div>
    <el-descriptions class="descript-box" v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="专利成果编号" label-align="right" align="left" width="120px" span="2">{{item.zlcgbh}}</el-descriptions-item>
      <el-descriptions-item label="专利成果名称" label-align="right" align="left" width="120px" span="2">{{item.zlcgmc}}</el-descriptions-item>
      <el-descriptions-item label="批准日期" label-align="right" align="left" width="120px" span="2">{{item.pzrq}}</el-descriptions-item>
      <el-descriptions-item label="专利发明人" label-align="right" align="left" width="120px" span="2">{{item.zlfmr}}</el-descriptions-item>
      <el-descriptions-item label="专利证书编号" label-align="right" align="left" width="120px" span="4">{{item.zlzsbh}}</el-descriptions-item>
      <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = {
        url: '/api/v2/renliziyuan/jiaozhigongzhuanlichengguo/list',
        data: { id: props.row.id, order: 'gh', sort: 'asc' }
      }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
